import { Link } from "react-router-dom";
import { NoindexSeo } from "@/components/Seo";

export default function NotFoundPage() {
  return (
    <main className="mx-auto max-w-md px-6 py-16 text-center">
      <NoindexSeo title="Page introuvable" />
      <h1 className="text-3xl font-bold">404</h1>
      <p className="mt-2">Page introuvable.</p>
      <Link className="mt-6 inline-block underline" to="/">
        Retour à l&apos;accueil
      </Link>
    </main>
  );
}
